import { createFeatureSelector, createSelector, select, Store } from '@ngrx/store'
import { State } from './rooms.state'
import * as reducer from './rooms.reducer'
import { combineLatest } from 'rxjs'
import { filter, map } from 'rxjs/operators'

export const roomsState = createFeatureSelector<State>('rooms-lib')

export const selectAllRooms = createSelector(roomsState, reducer.selectAll)

export const selectRoomsLoaded = createSelector(roomsState, (state) => state.isLoaded)

export const selectRooms = (rentalId: string) => (store: Store<State>) =>
  combineLatest([store.pipe(select(selectAllRooms)), store.pipe(select(selectRoomsLoaded))]).pipe(
    filter(([, loaded]) => loaded),
    map(([rooms]) => rooms.filter((room) => room.rental_id === rentalId).sort((a, b) => a.created - b.created))
  )
